module.exports = __webpack_public_path__ + "media/bootstrap-icons/bug-fill-817017fe.svg";